import React from 'react';

const Page = React.lazy(() => import('./CustomerStatementReportPage'));

const CustomerStatementReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/customer-statement',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default CustomerStatementReportConfig;
